const $ = window.jQuery;

export default function enableAccordions() {
var duration = { duration: 300 };
    $('.ui-accordion-header').on('click', (event) => {
      var $target = $(event.target);
      var $wrapper = $target.closest('ul');
      var $content = $target.siblings('.ui-accordion-content');
      if (!$target.hasClass('ui-state-active')) {
        $content.stop().slideDown(duration);
      } else {
        $content.stop().slideUp(duration);
      }
      if ($wrapper) {
        $('.ui-accordion-content', $wrapper).not($content).slideUp(duration).siblings('.ui-accordion-header').removeClass('ui-state-active');
      }
      $target.toggleClass('ui-state-active');
    });
    $(document).on('click', '.resource-header', (event) => {
      var $target = $(event.target).closest('.resource-header');
      var $wrapper = $target.closest('.posts');
      var $content = $target.siblings('.content');

      if (!$content) { return; }

      if (!$target.hasClass('active')) {
        $content.stop().slideDown(duration);
      } else {
        $content.stop().slideUp(duration);
      }
      if ($wrapper) {
        $('.content', $wrapper).not($content).slideUp(duration).siblings('.resource-header').removeClass('active');
      }
      $target.toggleClass('active');
    });
}



/** WEBPACK FOOTER **
 ** ./src/assets/foi/js/accordion.js
 **/